import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Box, IconButton, Typography, Skeleton } from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import LandingDashboardCard from './LandingDashboardCard';
import routes from '../../../../routes';
import OverlayLoader from '../../../../components/OverlayLoader';
import AchievementBadge from '../../../../components/AchievementBadge';
import './BadgesSliderStyles.css';

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <IconButton
      sx={{
        display: 'block',
        right: -30,
        position: 'absolute',
        top: '45%',
        transform: 'translate(0, -50%)',
        opacity: 0.5,
        zIndex: 10,
      }}
      onClick={onClick}
      size="large"
    >
      <ArrowForwardIos sx={{ color: 'black' }} />
    </IconButton>
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <IconButton
      sx={{
        display: 'block',
        left: -25,
        position: 'absolute',
        top: '45%',
        transform: 'translate(0, -50%)',
        opacity: 0.5,
        zIndex: 10,
      }}
      onClick={onClick}
      size="large"
    >
      <ArrowBackIos sx={{ color: 'black' }} />
    </IconButton>
  );
};

const MyBadgesDashboardCard = ({ isLoading, badgesList = [], id = '' }) => {
  const settings = {
    className: 'center',
    centerMode: true,
    swipeToSlide: true,
    arrows: true,
    infinite: true,
    centerPadding: 0,
    slidesToShow: 3,
    speed: 500,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <LandingDashboardCard title="My Badges" to={routes.mobileDashboardBadges} id={id}>
      <OverlayLoader wrapperStyles={{ height: '100%' }} isLoading={isLoading}>
        {isLoading && (
          <Box py={2} px={2} height={132} gap={2} display="flex" justifyContent="center" alignItems="center">
            <Skeleton variant="circular" width={80} height={80} />
            <Skeleton variant="circular" width={100} height={100} />
            <Skeleton variant="circular" width={80} height={80} />
          </Box>
        )}

        {!isLoading && (
          <Box pt={2} px={2} className="badges-slider">
            <Slider {...settings}>{badgesList.map((badge) => (
                <Box maxWidth="100px" height="116px" key={badge.id}>
                  <AchievementBadge color="secondary">
                    <Box textAlign="center" display="flex" flexDirection="column" rowGap="16px">
                      <img
                        style={{
                          width: '100%',
                          filter: badge?.awarded
                            ? 'drop-shadow(1px 4px 8px #ccc)'
                            : 'drop-shadow(1px 4px 8px #ccc) opacity(0.4) grayscale(1)',
                          borderRadius: '50%',
                          borderStyle: 'dashed',
                          boxShadow: 'rgb(255 255 255 / 75%) -1px 1px 0px 5px',
                        }}
                        src={badge.image_uri}
                        alt={badge.title}
                      />
                      <Typography variant="caption" component="span" color="textSecondary">
                        {badge.title}
                      </Typography>
                    </Box>
                  </AchievementBadge>
                </Box>
              ))}
            </Slider>
          </Box>
        )}
      </OverlayLoader>
    </LandingDashboardCard>
  );
};

export default MyBadgesDashboardCard;
